/**
 * Plugin operates the main confirm modal added to the APP root element.
 *
 * Usage:
 *   - from component
 *      this.$confirmPluginModal.show(params);
 *   - from actions or other resources that do not have an access to the vue object
 *      - pass in the 'this.$confirmModal' as parameter
 *      - then call 'show' on that parameter
 *
 * @param title Optional. Title for the modal. If omitted then the type is used as title.
 * @param message Message for the modal content box.
 * @param type Optional. Type of the modal. Possible options are 'ERROR', 'INFO'. Default 'INFO'.
 * @param buttonVariant Optional. 'RED' is the only available option now. Default will show blue button.
 * @param confirmButtonText Optional. Text for the callback button. Default 'Confirm'.
 * @param confirmCallback Optional. Method to be executed from the modal.
 * @param autoClose Optional. Will not close the modal imediatelly but it will show spinner in the confirm button. Modal has to be closed manually by calling close method on the plugin. In case of error call finishWorking to remove spinner.
 */

import ConfirmModalComponent from './Confirm.modal';

const ConfirmPluginModal = {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Vue.component('ConfirmModalSb', ConfirmModalComponent);
    Vue.prototype.$confirmPluginModal = {
      show(params) {
        Vue.prototype.$infoModalEventBus.$emit('show-confirm-modal', params);
      },
      close() {
        Vue.prototype.$infoModalEventBus.$emit('close-confirm-modal');
      },
      finishWorking() {
        Vue.prototype.$infoModalEventBus.$emit('finish-working-confirm-modal');
      },
    };
  },
};

export default ConfirmPluginModal;
